import React from 'react';

const Trope1: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-1 prefix__trope-decor"
      transform="translate(200, 210)"
    >
      <path
        d="M369.72,128.72s45.1-25,68.67-24.67c47.33.67,78.67,22,78.67,22s-20-26.68,2.66-30,12.67-26.67-4-40.67-41.33-38.66-91.33-24c-38.91,11.42-53.33,24.67-53.33,24.67S356.12,64.31,357,72.5c2,18.5,21.91,10.61,21.06,17-.66,4.94-11.29,13.27-12.5,19A26,26,0,0,0,369.72,128.72Z"
        fill="#f1ce58"
      />
      <ellipse
        cx="362.41"
        cy="72.99"
        rx="5.43"
        ry="2"
        transform="translate(-6.93 88.95) rotate(-13.86)"
        fill="#e1a554"
      />
      <path
        d="M365.21,71.43c.49,2-1.4,2.59-4,3.24s-5,1.09-5.49-.89a5.48,5.48,0,0,1,3.69-6C362,67.18,364.72,69.45,365.21,71.43Z"
        fill="#eebf57"
      />
      <path
        d="M362,68a4.39,4.39,0,0,1,.92,1.7c.49,2-1.4,2.59-4,3.24a15.57,15.57,0,0,1-3.21.54c0,.09,0,.18.05.26.49,2,2.86,1.54,5.49.89s4.51-1.25,4-3.24A5.49,5.49,0,0,0,362,68Z"
        fill="#d6974f"
      />
      <path
        d="M451.06,66.05a21.41,21.41,0,0,0-21-2.5c-8.5,3.5-17.5,9.5-22,10.5s-14.5,3.5-14.5,10,14.5,8.5,25,3,29.5-3.5,35.5-4.5S454.56,68.55,451.06,66.05Z"
        fill="#eebf57"
      />
      <path
        d="M504.06,74.05c-13.7-6.22-23-7-31.5-5.5s-9.5,6.5-5,12.5,17,4,30,9.5,22.5,9,24,1S509.56,76.55,504.06,74.05Z"
        fill="#eebf57"
      />
      <path
        d="M353.72,104.05c8.12-.59,13.84-2.5,22.34-5.5s16-9.5,13.5-15.5-29-1.5-37.5,4.5S346.89,104.55,353.72,104.05Z"
        fill="#eebf57"
      />
      <path
        d="M424.56,36.38c-6.19-3-29.34,3.17-35.84,7.67s-17.66,13.33-17.16,23.33,24.5-3,35.5-5.5S440.06,43.88,424.56,36.38Z"
        fill="#eebf57"
      />
      <path
        d="M486.06,38.55a77.69,77.69,0,0,0-37.5-4.5c-11.5,1.5-13.5,9-13,15.5s10,4.5,18.5,5.5,40,6,38,0S491.06,40.55,486.06,38.55Z"
        fill="#eebf57"
      />
      <ellipse
        cx="522.61"
        cy="79.54"
        rx="2"
        ry="5.43"
        transform="translate(309.22 563.19) rotate(-74.85)"
        fill="#e1a554"
      />
      <path
        d="M525.81,79.54c-.53,2-2.47,1.58-5.08.88S515.82,79,516.36,77a5.49,5.49,0,0,1,6.11-3.42C525.08,74.27,526.35,77.57,525.81,79.54Z"
        fill="#eebf57"
      />
      <path
        d="M524.62,75a4.5,4.5,0,0,1,0,1.94c-.54,2-2.48,1.58-5.09.88a15.6,15.6,0,0,1-3.07-1.08,2.41,2.41,0,0,0-.08.25c-.54,2,1.76,2.73,4.37,3.44s4.55,1.09,5.08-.88A5.49,5.49,0,0,0,524.62,75Z"
        fill="#d6974f"
      />
      <ellipse cx="464.89" cy="65.21" rx="4.54" ry="1.67" fill="#e1a554" />
      <path
        d="M467.47,64.51c0,1.71-1.65,1.82-3.91,1.82s-4.27-.11-4.27-1.82a4.58,4.58,0,0,1,4.18-4.09A4.4,4.4,0,0,1,467.47,64.51Z"
        fill="#eebf57"
      />
      <path
        d="M465.52,61.11a3.76,3.76,0,0,1,.4,1.56c0,1.71-1.65,1.82-3.91,1.82a12.33,12.33,0,0,1-2.7-.2,1.8,1.8,0,0,0,0,.22c0,1.71,2,1.82,4.27,1.82s3.91-.11,3.91-1.82A4.55,4.55,0,0,0,465.52,61.11Z"
        fill="#d6974f"
      />
      <path
        d="M424.56,36.38a8.07,8.07,0,0,0-2.35-.63c6.67,8-11.67,20.42-21.4,22.63-7.56,1.72-21.24,8.39-29.23,9.16.75,9.69,24.54-3.17,35.48-5.66S440.06,43.88,424.56,36.38Z"
        fill="#e1a554"
      />
      <path
        d="M492.06,55.05c-1.51-4.5-1.32-10.41-3.24-13.93.58,3.18-.48,6.64-4.76,9.18-5.44,3.23-27,2-35.5,1-5.17-.61-9.95-.76-13-2.24,0,.16,0,.33,0,.49.5,6.5,10,4.5,18.5,5.5S494.06,61.05,492.06,55.05Z"
        fill="#e1a554"
      />
      <path
        d="M389.56,83.05c-.53-1.27-2.15-2.07-4.45-2.48a2.31,2.31,0,0,1,.28.48c2.5,6-5,12.5-13.5,15.5s-14.22,4.91-22.33,5.5a4.42,4.42,0,0,1-.63,0,5.73,5.73,0,0,0,4.79,2c8.12-.59,13.84-2.5,22.34-5.5S392.06,89.05,389.56,83.05Z"
        fill="#e1a554"
      />
      <polygon
        points="9.81 69.39 5.19 66.99 0 67.46 2.4 62.84 1.93 57.65 6.56 60.05 11.75 59.58 9.34 64.2 9.81 69.39"
        fill="#fff"
      />
      <path
        d="M451.06,66.05c-.37-.26-.74-.51-1.13-.75,2.51,4.76,4.06,11.54-.21,12.25-6,1-25-1-35.5,4.5-6.91,3.62-15.56,4-20.66,2v0c0,6.5,14.5,8.5,25,3s29.5-3.5,35.5-4.5S454.56,68.55,451.06,66.05Z"
        fill="#e1a554"
      />
      <ellipse cx="426.43" cy="61.71" rx="2.61" ry="0.96" fill="#e1a554" />
      <path
        d="M428.13,60.65c0,1-.94,1-2.24,1s-2.46-.06-2.46-1a2.64,2.64,0,0,1,2.41-2.35A2.53,2.53,0,0,1,428.13,60.65Z"
        fill="#eebf57"
      />
      <path
        d="M427,58.7a2,2,0,0,1,.23.89c0,1-.95,1-2.24,1a7.38,7.38,0,0,1-1.56-.11s0,.08,0,.12c0,1,1.16,1,2.46,1s2.24-.06,2.24-1A2.6,2.6,0,0,0,427,58.7Z"
        fill="#d6974f"
      />
      <path
        d="M521.28,88c-1.78,7.39-11.15,3.93-23.89-1.46-13-5.5-25.5-3.5-30-9.5a14.57,14.57,0,0,1-2.2-4c-.76,2.19.11,5,2.37,8,4.5,6,17,4,30,9.5s22.5,9,24,1A7.09,7.09,0,0,0,521.28,88Z"
        fill="#e1a554"
      />
      <path
        d="M339.32,79.54c-1.51,4.3-11.9,2.34-23.54-1.75S295.56,69.33,297.08,65s11.9-5.09,23.54-1S340.83,75.23,339.32,79.54Z"
        fill="#f1ce58"
      />
      <path
        d="M573.22,25.57c1.46,5.42-10.42,10.64-25.05,14.58s-26.34,5.49-27.8.07,8.52-13.42,23.14-17.36S571.77,20.16,573.22,25.57Z"
        fill="#f1ce58"
      />
      <path
        d="M332,69.6a5.16,5.16,0,0,1,.78,4.32c-1.61,4.59-11.73,2.84-23-1.13a82.36,82.36,0,0,1-11.63-4.92c.7,3.95,8.25,7.7,18.08,11.16,11.28,4,21.4,5.72,23,1.12C340.26,77.2,337.25,73.16,332,69.6Z"
        fill="#e1a554"
      />
      <path
        d="M291.22,37.91c0,4.56-10.47,6.13-22.81,6.1s-21.87-1.33-21.86-5.89,9.57-8.73,21.9-8.7S291.23,33.34,291.22,37.91Z"
        fill="#f1ce58"
      />
      <path
        d="M281,30.94a5.1,5.1,0,0,1,2.16,3.82c0,4.87-10.14,6.54-22.09,6.51a82.71,82.71,0,0,1-12.61-.81c2,3.5,10.32,4.55,20.75,4.58,11.95,0,22.09-1.65,22.1-6.52C291.34,35.39,287.17,32.57,281,30.94Z"
        fill="#e1a554"
      />
      <path
        d="M286.93,64.12c.1,4.56-10.31,6.4-22.64,6.68s-21.9-.76-22-5.32,9.34-9,21.67-9.26S286.82,59.55,286.93,64.12Z"
        fill="#f1ce58"
      />
      <path
        d="M276.55,57.41a5.19,5.19,0,0,1,2.27,3.77c.11,4.87-10,6.8-21.93,7.08a81.68,81.68,0,0,1-12.62-.49c2,3.45,10.44,4.28,20.86,4,11.95-.28,22-2.21,21.92-7.08C287,61.6,282.74,58.89,276.55,57.41Z"
        fill="#e1a554"
      />
      <path
        d="M118.93,48.14c1,3.38-6.44,6.76-15.57,9.36S86.91,61.16,86,57.79s5.22-8.49,14.34-11.09S118,44.76,118.93,48.14Z"
        fill="#f1ce58"
      />
      <path
        d="M109.91,45.15a4,4,0,0,1,2.41,2.37c1,3.6-6.11,7-15,9.51a61.53,61.53,0,0,1-9.49,2.07c2.19,2.18,8.6,1.18,16.31-1,8.85-2.51,16-5.91,15-9.51C118.48,46.26,114.8,45.05,109.91,45.15Z"
        fill="#e1a554"
      />
      <path
        d="M72.53,64.13c1,3.37-6.43,6.75-15.56,9.35s-16.46,3.67-17.42.29,5.22-8.48,14.35-11.08S71.57,60.75,72.53,64.13Z"
        fill="#f1ce58"
      />
      <path
        d="M63.51,61.14a4,4,0,0,1,2.42,2.36c1,3.61-6.12,7-15,9.52a64.25,64.25,0,0,1-9.49,2.07c2.19,2.17,8.6,1.17,16.31-1,8.85-2.52,16-5.91,15-9.51C72.09,62.24,68.41,61,63.51,61.14Z"
        fill="#e1a554"
      />
      <path
        d="M87.25,46.56c.67,2.37-4.54,4.75-11,6.58S64.7,55.72,64,53.35s3.67-6,10.1-7.8S86.57,44.18,87.25,46.56Z"
        fill="#f1ce58"
      />
      <path
        d="M80.9,44.45a2.83,2.83,0,0,1,1.7,1.67c.72,2.54-4.31,4.92-10.53,6.7a44.93,44.93,0,0,1-6.69,1.45c1.55,1.53,6.06.83,11.49-.71,6.22-1.78,11.25-4.16,10.53-6.7C86.93,45.23,84.34,44.38,80.9,44.45Z"
        fill="#e1a554"
      />
      <path
        d="M354.78,64.38c-1,2.8-7.75,1.52-15.33-1.14s-13.17-5.51-12.18-8.32,7.75-3.31,15.33-.65S355.77,61.57,354.78,64.38Z"
        fill="#f1ce58"
      />
      <path
        d="M350,57.9a3.38,3.38,0,0,1,.51,2.82c-1,3-7.64,1.84-15-.74a53.55,53.55,0,0,1-7.57-3.2c.45,2.57,5.37,5,11.77,7.26,7.35,2.59,13.94,3.73,15,.74C355.4,62.86,353.44,60.22,350,57.9Z"
        fill="#e1a554"
      />
      <path
        d="M321.83,52.49c-1,2.81-7.75,1.53-15.33-1.14S293.33,45.84,294.31,43s7.76-3.32,15.34-.65S322.82,49.69,321.83,52.49Z"
        fill="#f1ce58"
      />
      <path
        d="M317.05,46a3.37,3.37,0,0,1,.52,2.81c-1.06,3-7.65,1.85-15-.73A52,52,0,0,1,295,44.89c.45,2.57,5.37,5,11.78,7.27,7.34,2.58,13.93,3.73,15,.73C322.44,51,320.48,48.34,317.05,46Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M137,56.08c.65,3.52-4.88,5.8-11.67,7.05s-12.23,1.24-12.87-2.27,4-7.72,10.8-9S136.34,52.56,137,56.08Z"
          fill="#f1ce58"
        />
        <path
          d="M130.58,51.91a4,4,0,0,1,1.76,2.49c.64,3.48-5,5.78-11.88,7.05a39,39,0,0,1-7.37.77c1.59,2.29,6.55,2.14,12.57,1,6.89-1.27,12.52-3.56,11.87-7C137.12,54,134.34,52.41,130.58,51.91Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M60.6,49.82c.64,3.51-4.89,5.8-11.68,7S36.7,58.11,36.05,54.59s4-7.71,10.8-9S60,46.3,60.6,49.82Z"
          fill="#f1ce58"
        />
        <path
          d="M54.18,45.64a4,4,0,0,1,1.76,2.5c.64,3.48-5,5.77-11.87,7a38.41,38.41,0,0,1-7.38.78c1.6,2.29,6.56,2.14,12.57,1,6.9-1.27,12.52-3.56,11.88-7C60.73,47.72,58,46.15,54.18,45.64Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <ellipse
          cx="337.27"
          cy="45.24"
          rx="5.43"
          ry="2"
          transform="translate(41.44 213.42) rotate(-37.26)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <g>
          <path
            d="M339.23,42.7c1.23,1.62-.26,2.93-2.41,4.56s-4.15,3-5.39,1.37a5.5,5.5,0,0,1,1-6.93C334.6,40.06,338,41.07,339.23,42.7Z"
            fill="#eebf57"
          />
          <path
            d="M334.9,40.87a4.43,4.43,0,0,1,1.52,1.2c1.23,1.63-.26,2.93-2.41,4.57a16,16,0,0,1-2.72,1.77l.14.22c1.24,1.62,3.24.27,5.39-1.37s3.64-2.94,2.41-4.56A5.5,5.5,0,0,0,334.9,40.87Z"
            fill="#d6974f"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="104.21"
          cy="39.34"
          rx="5.43"
          ry="2"
          transform="translate(-1.89 5.42) rotate(-2.95)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <g>
          <path
            d="M107.26,38.34c.1,2-1.86,2.28-4.57,2.42s-5.11.13-5.22-1.91a5.51,5.51,0,0,1,4.75-5.15C104.92,33.56,107.15,36.3,107.26,38.34Z"
            fill="#eebf57"
          />
          <path
            d="M104.71,34.39a4.41,4.41,0,0,1,.58,1.85c.1,2-1.86,2.27-4.56,2.41a15,15,0,0,1-3.25-.06,2.17,2.17,0,0,0,0,.26c.11,2,2.52,2,5.22,1.91s4.67-.38,4.57-2.42A5.5,5.5,0,0,0,104.71,34.39Z"
            fill="#d6974f"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="82.23"
          cy="66.21"
          rx="5.43"
          ry="2"
          transform="translate(-3.3 4.33) rotate(-2.95)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <g>
          <path
            d="M85.28,65.22c.1,2-1.86,2.27-4.56,2.41s-5.12.13-5.22-1.91a5.49,5.49,0,0,1,4.74-5.15C82.94,60.43,85.17,63.18,85.28,65.22Z"
            fill="#eebf57"
          />
          <path
            d="M82.73,61.27a4.42,4.42,0,0,1,.58,1.84c.1,2-1.86,2.28-4.56,2.42a15.55,15.55,0,0,1-3.25-.07,2.25,2.25,0,0,0,0,.26c.1,2,2.52,2,5.22,1.91s4.66-.37,4.56-2.41A5.48,5.48,0,0,0,82.73,61.27Z"
            fill="#d6974f"
          />
        </g>
      </g>
      <ellipse
        cx="287.31"
        cy="117.48"
        rx="1.5"
        ry="4.08"
        transform="translate(167.38 403.78) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M289.63,116.87c0,1.54-1.49,1.62-3.52,1.61s-3.84-.14-3.83-1.67a4.13,4.13,0,0,1,3.79-3.64A3.94,3.94,0,0,1,289.63,116.87Z"
        fill="#eebf57"
      />
      <path
        d="M287.9,113.8a3.18,3.18,0,0,1,.35,1.41c0,1.53-1.49,1.62-3.52,1.6a11.1,11.1,0,0,1-2.43-.2,1.5,1.5,0,0,0,0,.2c0,1.53,1.8,1.65,3.83,1.67s3.51-.07,3.52-1.61A4.09,4.09,0,0,0,287.9,113.8Z"
        fill="#d6974f"
      />
      <ellipse
        cx="192.86"
        cy="104.5"
        rx="1.71"
        ry="4.65"
        transform="translate(86.72 296.45) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M195.51,103.8c0,1.75-1.71,1.85-4,1.83s-4.38-.15-4.36-1.9a4.7,4.7,0,0,1,4.32-4.16C193.76,99.59,195.53,102.05,195.51,103.8Z"
        fill="#eebf57"
      />
      <path
        d="M193.54,100.3a3.78,3.78,0,0,1,.4,1.6c0,1.75-1.71,1.85-4,1.83a13.46,13.46,0,0,1-2.77-.22,1.64,1.64,0,0,0,0,.22c0,1.75,2.05,1.88,4.36,1.9s4-.08,4-1.83A4.68,4.68,0,0,0,193.54,100.3Z"
        fill="#d6974f"
      />
      <ellipse
        cx="345.42"
        cy="117.15"
        rx="1.32"
        ry="3.6"
        transform="translate(225.33 461.55) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M347.47,116.61c0,1.35-1.32,1.43-3.11,1.41s-3.38-.11-3.37-1.47a3.63,3.63,0,0,1,3.34-3.21A3.47,3.47,0,0,1,347.47,116.61Z"
        fill="#eebf57"
      />
      <path
        d="M346,113.9a3,3,0,0,1,.31,1.24c0,1.35-1.32,1.43-3.12,1.41a9.87,9.87,0,0,1-2.14-.17,1,1,0,0,0,0,.17c0,1.36,1.58,1.46,3.37,1.47s3.1-.06,3.11-1.41A3.6,3.6,0,0,0,346,113.9Z"
        fill="#d6974f"
      />
      <path
        d="M653.07,104.23a2.57,2.57,0,0,1,0,.48c-.27,6.67-15.64,8.4-33.66,7.68-10.89-.43-20.25-1.48-25.91-3.72a3.93,3.93,0,0,0-.06.59c-.27,6.67,13.61,9.08,31.63,9.8s33.4-1,33.67-7.68C658.86,108.84,656.73,106.36,653.07,104.23Z"
        fill="#e1a554"
      />
      <path
        d="M567.71,21.43c.47,5.2-11.07,10.2-25.16,14-9.19,2.48-17.24,4-22.31,3.45a4.39,4.39,0,0,0,.13,1.31c1.46,5.42,13.18,3.87,27.8-.07S574.68,31,573.22,25.53C572.71,23.64,570.71,22.26,567.71,21.43Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M585.23,46.59c.8,3.79-7.6,6.95-17.85,9.11s-18.39,2.78-19.19-1,6.39-8.94,16.64-11.1S584.43,42.8,585.23,46.59Z"
          fill="#f1ce58"
        />
        <path
          d="M581.58,43.55c.13,3.61-8,6.61-17.89,8.7-6.45,1.36-12.06,2.11-15.54,1.53a3.06,3.06,0,0,0,0,.91c.8,3.79,8.95,3.17,19.19,1s18.65-5.32,17.85-9.11C585,45.26,583.62,44.23,581.58,43.55Z"
          fill="#e1a554"
        />
      </g>
      <path
        d="M865.07,38c.12-3.29-2.23-6.39-6-8.7a6.8,6.8,0,0,1,.41,2.52c-.22,6.45-9.67,8.38-20.73,8-5.43-.18-10.24-.79-13.71-2.11.35,5.95,8.62,7.92,19.31,8.29C855.4,46.37,864.86,44.44,865.07,38Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M544,51c1,3.37-3.91,6.22-10.2,8.2s-11.43,2.57-12.48-.79,2.85-8,9.13-10S542.9,47.6,544,51Z"
          fill="#f1ce58"
        />
        <path
          d="M544,51c-.54-1.71-2.42-2.85-5-3.3a3.53,3.53,0,0,1,.69,1.22c1.05,3.36-3.91,6.22-10.2,8.2a28.92,28.92,0,0,1-8.08,1.6c1.27,3,6.28,2.39,12.35.48C540,57.18,545,54.33,544,51Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M864.69,37.19c-.18,6.45-9.62,8.43-20.69,8.12S824.43,43,824.61,36.52s8.91-12.13,20-11.81S864.87,30.74,864.69,37.19Z"
          fill="#f1ce58"
        />
        <g>
          <path
            d="M877.63,72.62c-2,6.15-11.58,5.47-22.13,2.12S837.33,67.1,839.28,61s11.9-9.2,22.45-5.86S879.58,66.47,877.63,72.62Z"
            fill="#f1ce58"
          />
          <path
            d="M877.63,72.62c1-3.13-.43-6.75-3.44-10a7,7,0,0,1-.29,2.54c-1.95,6.15-11.58,5.47-22.13,2.12-5.18-1.64-9.64-3.51-12.63-5.72-1.27,5.82,6.17,10,16.36,13.18C866.05,78.09,875.68,78.77,877.63,72.62Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M918.05,38.23c-.95,6.38-10.56,7.24-21.51,5.62s-19.15-4.64-18.21-11,10.27-11,21.22-9.37S919,31.84,918.05,38.23Z"
            fill="#f1ce58"
          />
          <path
            d="M918.05,38.23c.48-3.26-1.5-6.61-5-9.33a6.91,6.91,0,0,1,.12,2.56c-.94,6.38-10.55,7.24-21.5,5.62-5.38-.79-10.08-1.93-13.38-3.63-.32,5.95,7.67,8.84,18.25,10.4C907.49,45.47,917.1,44.61,918.05,38.23Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M922.28,71.86c-1.27,5.16-9.2,5.11-18,2.94s-15.33-5.29-14.06-10.45,9.27-8.19,18.11-6S923.55,66.71,922.28,71.86Z"
            fill="#f1ce58"
          />
          <path
            d="M922.28,71.86a7.19,7.19,0,0,0-1.38-5.72,5.53,5.53,0,0,1-.14,1.35c-1.27,5.15-9.2,5.11-18,2.93-5.63-1.38-10.29-3.15-12.62-5.58-.75,4.86,5.58,7.85,14.14,10C913.08,77,921,77,922.28,71.86Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M772.28,50.2c-.59,3.52-5.92,3.89-12,2.87s-10.55-2.78-10-6.3,5.81-6,11.85-5S772.88,46.68,772.28,50.2Z"
            fill="#f1ce58"
          />
          <path
            d="M772.28,50.2a4.77,4.77,0,0,0-1.21-3.77,3.47,3.47,0,0,1,0,.91c-.6,3.52-5.92,3.89-12,2.87-3.84-.64-7.06-1.6-8.74-3.11-.26,3.3,4.14,5,10,6C766.37,54.09,771.69,53.72,772.28,50.2Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M829,57.1c-.59,3.52-5.91,3.89-12,2.87s-10.55-2.78-10-6.3,5.81-6,11.85-5S829.57,53.57,829,57.1Z"
            fill="#f1ce58"
          />
          <path
            d="M829,57.1a4.77,4.77,0,0,0-1.21-3.77,3.48,3.48,0,0,1,0,.91c-.6,3.52-5.92,3.89-12,2.87-3.84-.65-7.06-1.6-8.74-3.11-.26,3.3,4.14,5,10,6C823.06,61,828.38,60.62,829,57.1Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M808,40.53c-.79,4.71-7.92,5.21-16,3.85s-14.13-3.73-13.34-8.44,7.78-8,15.87-6.63S808.77,35.81,808,40.53Z"
            fill="#f1ce58"
          />
          <path
            d="M808,40.53a6.43,6.43,0,0,0-1.62-5.05,5.53,5.53,0,0,1,0,1.22c-.8,4.71-7.93,5.21-16,3.85-5.15-.87-9.46-2.15-11.71-4.17-.35,4.42,5.54,6.68,13.37,8C800.05,45.74,807.18,45.24,808,40.53Z"
            fill="#e1a554"
          />
        </g>
        <g>
          <path
            d="M822.43,25.13c-.3,3.56-5.58,4.38-11.68,3.87S800,27.11,800.3,23.55s5.29-6.43,11.39-5.92S822.72,21.58,822.43,25.13Z"
            fill="#f1ce58"
          />
          <path
            d="M822.43,25.13a4.85,4.85,0,0,0-1.52-3.65,4.59,4.59,0,0,1,.05.91c-.3,3.56-5.58,4.37-11.68,3.86-3.89-.32-7.18-1-9-2.37,0,3.31,4.54,4.63,10.45,5.12C816.85,29.51,822.13,28.69,822.43,25.13Z"
            fill="#e1a554"
          />
        </g>
      </g>
      <path
        d="M685,15.51c1.43,6.29-7.23,10.56-18,13s-19.54,2.59-21-3.7,5.62-13.95,16.41-16.4S683.56,9.21,685,15.51Z"
        fill="#f1ce58"
      />
      <g>
        <path
          d="M706.32,46.62c-.36,6.44-9.85,8.16-20.9,7.55s-19.5-2.89-19.14-9.33S675.52,33,686.57,33.58,706.68,40.18,706.32,46.62Z"
          fill="#f1ce58"
        />
        <path
          d="M706.32,46.62c.19-3.29-2.09-6.44-5.81-8.84a7.1,7.1,0,0,1,.35,2.54c-.36,6.44-9.86,8.17-20.91,7.55-5.42-.31-10.21-1-13.65-2.41.21,6,8.44,8.11,19.12,8.71C696.47,54.78,706,53.06,706.32,46.62Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M1141.61,83.07c-1.95,3.23-10.95,0-20.76-5S1104,68.1,1105.92,64.86s11.33-2.26,21.14,2.83S1143.55,79.83,1141.61,83.07Z"
          fill="#f1ce58"
        />
        <path
          d="M1141.61,83.07c1-1.65-.27-4.29-3-7.16a2.56,2.56,0,0,1-.32,1.49c-2,3.23-11,0-20.76-5.05a74.22,74.22,0,0,1-11.72-7.15c-1.3,3.23,5.58,7.9,15.07,12.82C1130.66,83.11,1139.66,86.3,1141.61,83.07Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M1120,100.88c-1.43,2.38-8,0-15.26-3.71s-12.41-7.3-11-9.68,8.33-1.66,15.55,2.09S1121.43,98.5,1120,100.88Z"
          fill="#f1ce58"
        />
        <path
          d="M1120,100.88c.73-1.21-.19-3.15-2.22-5.26a1.89,1.89,0,0,1-.24,1.09c-1.43,2.38-8,0-15.26-3.71a54.54,54.54,0,0,1-8.62-5.26c-1,2.37,4.1,5.81,11.08,9.43C1112,100.92,1118.57,103.26,1120,100.88Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M1100,64.52c-1.43,2.38-8,0-15.26-3.71s-12.41-7.3-11-9.67,8.33-1.66,15.55,2.08S1101.44,62.15,1100,64.52Z"
          fill="#f1ce58"
        />
        <path
          d="M1100,64.52c.73-1.21-.19-3.15-2.22-5.26a1.87,1.87,0,0,1-.24,1.09c-1.43,2.38-8,0-15.26-3.71a53.8,53.8,0,0,1-8.62-5.26c-1,2.38,4.1,5.82,11.08,9.43C1092,64.56,1098.58,66.9,1100,64.52Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M740.89,9.9c.67,6.41-8.42,9.63-19.43,10.78s-19.71.27-20.38-6.15S708.3,1.34,719.31.18,740.22,3.48,740.89,9.9Z"
          fill="#f1ce58"
        />
        <path
          d="M740.89,9.9c-.34-3.28-3.09-6-7.15-7.8a7,7,0,0,1,.75,2.45c.67,6.42-8.42,9.64-19.43,10.79-5.41.57-10.25.64-13.87-.2,1.17,5.85,9.63,6.66,20.27,5.54C732.47,19.53,741.56,16.31,740.89,9.9Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M749.39,34.79c.05,5.31-7.65,7.24-16.75,7.32s-16.16-1.31-16.21-6.62,6.94-10.24,16-10.33S749.33,29.49,749.39,34.79Z"
          fill="#f1ce58"
        />
        <path
          d="M749.39,34.79a7.19,7.19,0,0,0-2.76-5.2,6.11,6.11,0,0,1,.2,1.34c0,5.31-7.65,7.23-16.75,7.32-5.79.06-10.75-.49-13.61-2.27.48,4.9,7.36,6.22,16.17,6.13C741.74,42,749.44,40.1,749.39,34.79Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M601.41,18.72c.3,3.56-4.77,5.24-10.88,5.75s-10.91-.07-11.21-3.63,4.15-7.22,10.25-7.74S601.1,15.16,601.41,18.72Z"
          fill="#f1ce58"
        />
        <path
          d="M601.41,18.72a4.82,4.82,0,0,0-2.11-3.35,4.48,4.48,0,0,1,.2.88c.3,3.56-4.77,5.24-10.88,5.76-3.88.33-7.24.21-9.24-.84.57,3.26,5.25,3.8,11.15,3.3C596.64,24,601.71,22.28,601.41,18.72Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M622,51.08c.3,3.56-4.77,5.24-10.87,5.76s-10.91-.08-11.21-3.64,4.14-7.22,10.25-7.74S621.7,47.52,622,51.08Z"
          fill="#f1ce58"
        />
        <path
          d="M622,51.08a4.79,4.79,0,0,0-2.11-3.35,3.38,3.38,0,0,1,.2.89c.3,3.55-4.77,5.24-10.87,5.75-3.89.33-7.24.21-9.25-.84.57,3.26,5.25,3.81,11.16,3.31C617.23,56.32,622.3,54.64,622,51.08Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M655.34,43.66c.3,3.56-4.77,5.24-10.87,5.76s-10.92-.07-11.22-3.63,4.15-7.22,10.25-7.74S655,40.1,655.34,43.66Z"
          fill="#f1ce58"
        />
        <path
          d="M655.34,43.66a4.84,4.84,0,0,0-2.11-3.35,4,4,0,0,1,.2.89c.3,3.56-4.77,5.24-10.87,5.76-3.89.33-7.24.2-9.25-.85.57,3.26,5.25,3.81,11.16,3.31C650.57,48.9,655.64,47.22,655.34,43.66Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M630.88,32.83c.4,4.76-6.38,7-14.56,7.71s-14.61-.1-15-4.87S606.86,26,615,25.31,630.48,28.06,630.88,32.83Z"
          fill="#f1ce58"
        />
        <path
          d="M630.88,32.83a6.48,6.48,0,0,0-2.83-4.49,4.46,4.46,0,0,1,.27,1.19c.41,4.77-6.38,7-14.56,7.71-5.2.44-9.69.27-12.38-1.13.77,4.37,7,5.1,14.94,4.43C624.5,39.84,631.28,37.59,630.88,32.83Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M641.06,14.33c.6,3.52-4.32,5.62-10.36,6.64s-10.88.84-11.47-2.68,3.52-7.54,9.57-8.57S640.46,10.81,641.06,14.33Z"
          fill="#f1ce58"
        />
        <path
          d="M641.06,14.33a4.83,4.83,0,0,0-2.38-3.16A3.74,3.74,0,0,1,639,12c.6,3.52-4.31,5.62-10.36,6.65-3.84.65-7.19.81-9.28-.07.84,3.2,5.55,3.35,11.39,2.36C636.74,20,641.66,17.85,641.06,14.33Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M781.75,22.21c-.29,3.56-5.57,4.37-11.68,3.86s-10.75-1.89-10.45-5.45,5.29-6.43,11.4-5.92S782.05,18.65,781.75,22.21Z"
          fill="#f1ce58"
        />
        <path
          d="M781.75,22.21a4.82,4.82,0,0,0-1.52-3.66,4,4,0,0,1,0,.91c-.3,3.56-5.58,4.37-11.68,3.87-3.89-.33-7.18-1-9-2.38,0,3.31,4.54,4.63,10.45,5.12C776.18,26.58,781.46,25.77,781.75,22.21Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M953.81,53.39c-1.29,5.15-9.22,5.06-18,2.84s-15.3-5.37-14-10.52,9.31-8.14,18.14-5.92S955.11,48.25,953.81,53.39Z"
          fill="#f1ce58"
        />
        <path
          d="M953.81,53.39a7.15,7.15,0,0,0-1.34-5.73,5.53,5.53,0,0,1-.15,1.35c-1.29,5.15-9.23,5.06-18.06,2.84-5.62-1.42-10.27-3.21-12.58-5.65-.78,4.85,5.53,7.88,14.08,10C944.59,58.45,952.52,58.54,953.81,53.39Z"
          fill="#e1a554"
        />
      </g>
      <ellipse
        cx="644.56"
        cy="95.23"
        rx="1.5"
        ry="4.08"
        transform="translate(543.83 738.95) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M646.88,94.62c0,1.54-1.49,1.62-3.52,1.61s-3.84-.14-3.83-1.67a4.13,4.13,0,0,1,3.79-3.64A3.94,3.94,0,0,1,646.88,94.62Z"
        fill="#eebf57"
      />
      <path
        d="M645.15,91.55A3.18,3.18,0,0,1,645.5,93c0,1.53-1.49,1.62-3.52,1.6a11.1,11.1,0,0,1-2.43-.2,1.5,1.5,0,0,0,0,.2c0,1.53,1.8,1.65,3.83,1.67s3.51-.07,3.52-1.61A4.09,4.09,0,0,0,645.15,91.55Z"
        fill="#d6974f"
      />
      <ellipse
        cx="751.93"
        cy="11.91"
        rx="4.08"
        ry="1.5"
        transform="translate(63.36 314.25) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M753.78,10.37c.63,1.4-.67,2.11-2.52,3s-3.53,1.51-4.17.12A4.12,4.12,0,0,1,749,8.53,4,4,0,0,1,753.78,10.37Z"
        fill="#eebf57"
      />
      <path
        d="M750.9,8.33a3.19,3.19,0,0,1,.92,1.12c.64,1.4-.67,2.1-2.51,3a11.27,11.27,0,0,1-2.29.85,1.46,1.46,0,0,1,.07.19c.64,1.39,2.33.73,4.17-.12s3.15-1.55,2.52-3A4.12,4.12,0,0,0,750.9,8.33Z"
        fill="#d6974f"
      />
      <ellipse
        cx="762.18"
        cy="29.66"
        rx="4.08"
        ry="1.5"
        transform="translate(56.9 320.13) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M764,28.12c.63,1.4-.67,2.11-2.52,2.95s-3.53,1.51-4.17.12a4.12,4.12,0,0,1,1.89-4.91A4,4,0,0,1,764,28.12Z"
        fill="#eebf57"
      />
      <path
        d="M761.15,26.08a3.19,3.19,0,0,1,.92,1.12c.64,1.4-.67,2.1-2.51,2.95a11.27,11.27,0,0,1-2.29.85,1.46,1.46,0,0,1,.07.19c.64,1.39,2.33.73,4.17-.12s3.15-1.55,2.52-2.95A4.12,4.12,0,0,0,761.15,26.08Z"
        fill="#d6974f"
      />
      <g>
        <ellipse
          cx="871.22"
          cy="48.08"
          rx="1.5"
          ry="4.08"
          transform="translate(630 886.62) rotate(-77.11)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M874.61,46.78c-.34,1.5-1.81,1.26-3.79.81s-3.72-1-3.37-2.45a4.11,4.11,0,0,1,4.48-2.74A4,4,0,0,1,874.61,46.78Z"
          fill="#eebf57"
        />
        <path
          d="M873.58,43.41a3.26,3.26,0,0,1,0,1.45c-.34,1.49-1.81,1.26-3.79.81A11.26,11.26,0,0,1,867.5,45a1.8,1.8,0,0,0,0,.19c-.35,1.5,1.4,2,3.37,2.45s3.45.69,3.79-.81A4.1,4.1,0,0,0,873.58,43.41Z"
          fill="#d6974f"
        />
      </g>
      <ellipse
        cx="894.19"
        cy="43.07"
        rx="1.5"
        ry="4.08"
        transform="translate(585.32 883.33) rotate(-72.57)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M896.6,43.16c-.46,1.46-1.91,1.12-3.84.51s-3.64-1.25-3.18-2.71a4.13,4.13,0,0,1,4.69-2.38A4,4,0,0,1,896.6,43.16Z"
        fill="#eebf57"
      />
      <path
        d="M895.84,39.72a3.46,3.46,0,0,1-.08,1.45c-.46,1.46-1.9,1.11-3.84.5a11.68,11.68,0,0,1-2.27-.89l-.07.18c-.46,1.46,1.24,2.1,3.18,2.71s3.38.95,3.84-.51A4.15,4.15,0,0,0,895.84,39.72Z"
        fill="#d6974f"
      />
    </g>
  );
};

export default Trope1;
